import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { OptionsChart } from './OptionsChart';

export function OptionsTab ({menuArray,userData}) {
  return(
  <>
    <Collapse in={menuArray[0]} className="m-0 p-0 ">
      <Row id="OptionsTab" className="m-0 p-0">
          <Col xs={12} className="m-0 p-2 pt-0 pagebreakportrait">
            <OptionsChart/>
          </Col>
      </Row>
    </Collapse>
  </>  
  );
}